import create from "zustand"
import {persist} from "zustand/middleware"
import shallow from "zustand/shallow"

/**
 * @type {import("services/appCenter/data").TGiantUser}
 */
const initialUserState = {
  MFAStatus: Boolean(false),
  gid: "",
  general: {},
  info: {
    firstName: "",
    lastName: "",
    gender: "",
    birthday: "",
    nationalityCode: "",
    height: "",
    weight: "",
    cityName: "",
    countryCode: "",
    formattedAddress: "",
    measureUnit: "Metric",
    profileImage: undefined,
    marketingConsent: false,
    dietType: undefined,
    dietNote: "",
    passportNumber: "",
    twNationalIdNo: "",
  },
  family: {},
  policyVersions: Array(0),
  linkExtProviders: {},
  registerFrom: "default",
}

/**
 * @type {import("./types").TGiantUserStore}
 */
export const useGiantUserStore = create(
  persist(
    set => ({
      ...initialUserState,
      setUserInfo: info => set({info}),
      setUserGeneral: general =>
        set(orig => ({general: {...orig.general, ...general}})),
      setUser: user => set(user),
      setMarketingConsent: status =>
        set(orig => ({info: {...orig.info, marketingConsent: status}})),
      setMFAStatus: status => set({MFAStatus: status}),
      reset: () => set(initialUserState),
    }),
    {
      name: "giant-id-user-store",
    },
  ),
)

export function getIsUserFamilyAdmin() {
  return useGiantUserStore.getState().family?.membership === "admin"
}

export function useUserInfo() {
  return useGiantUserStore(user => user.info, shallow)
}

export function useMeasureUnit() {
  return useGiantUserStore(user => user.info.measureUnit)
}

export const resetUserStore = useGiantUserStore.getState().reset
